import React from 'react';

function ApiKeysTableRowSkeleton() {
  return (
    <tr className="border-b border-border">
      {/* Key Name */}
      <td className="px-4 py-3">
        <div className="h-4 w-24 bg-muted rounded animate-pulse" />
      </td>

      {/* Prefix */}
      <td className="px-4 py-3">
        <div className="h-5 w-16 bg-muted rounded animate-pulse" />
      </td>

      {/* Scopes */}
      <td className="px-4 py-3">
        <div className="flex flex-wrap gap-1">
          <div className="h-5 w-16 bg-muted rounded-full animate-pulse" />
          <div className="h-5 w-20 bg-muted rounded-full animate-pulse" />
        </div>
      </td>

      {/* Created */}
      <td className="px-4 py-3">
        <div className="h-4 w-20 bg-muted rounded animate-pulse" />
      </td>

      {/* Last Used */}
      <td className="px-4 py-3">
        <div className="h-4 w-20 bg-muted rounded animate-pulse" />
      </td>

      {/* Expires */}
      <td className="px-4 py-3">
        <div className="h-4 w-28 bg-muted rounded animate-pulse" />
      </td>

      {/* Actions */}
      <td className="px-4 py-3 text-right">
        <div className="h-8 w-8 bg-muted rounded animate-pulse ml-auto" />
      </td>
    </tr>
  );
}

export default ApiKeysTableRowSkeleton;
